export default "/images/c72c099597fe7291ac879469ea344a03.avif";